<div class="generic-modal-root">
  <ngx-loading [show]="loading"></ngx-loading>

  <div class="row-padding">
    <div class="row">
      <form
        *ngIf="form"
        [formGroup]="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
        <div class="form-group m-form__group row remove-margin">
          <div class="col-lg-12" *ngIf="trackId < 0 && !copyMode">
            <app-file-upload
              multiple="false"
              (filesSet)="trackFileChanged($event)"
              [text]="
                uploadedTrackName != null ? uploadedTrackName : 'Choose file'
              "
              accept=".mp3"
            ></app-file-upload>
          </div>
        </div>
        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Title </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="title"
            />
          </div>
        </div>
        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Artist </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="artist"
            />
          </div>
        </div>
        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Notes </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="notes"
            />
          </div>
        </div>
        <div [hidden]="!hasSiteManagement" class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Light Show Json </label>
          <div class="col-lg-8">
            <textarea
              rows="12"
              type="text"
              class="form-control m-input"
              formControlName="lightShow"
            ></textarea>
          </div>
        </div>
        <div [hidden]="!hasSiteManagement"  class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Visible </label>
          <div class="col-lg-8">
            <input
              type="text"
              type="checkbox"
              class="form-control m-input"
              [checked]="isTrackVisible"
              (change)="toggleTrackVisible()"
              formControlName="visible"
            />
          </div>
        </div>
        <div [hidden]="!hasSiteManagement || copyMode || trackId > 0"  class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Reecode with constant bitrate </label>
          <div class="col-lg-8">
            <input
              type="text"
              type="checkbox"
              class="form-control m-input"
              formControlName="reencode"
            />
          </div>
        </div>
        <div *ngIf="genres" class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Genres </label>
          <div class="col-lg-8">
            <ng-select
              [items]="genres"
              multiple="true"
              bindLabel="name"
              selectableGroup="true"
              closeOnSelect="false"
              [(ngModel)]="trackGenres"
              [ngModelOptions]="{standalone: true}"
            >
            </ng-select>
          </div>
        </div>

        <div style="height: 45px;">
          <span style="color:red" *ngIf="form.invalid && form.dirty" class="m-form__help" >
            A track file, track name, artist, and !VALID! light show JSON are required
          </span><br>
          <button
            (click)="close()"
            class="btn btn-success"
            style="margin:10px; float:right"
          >
            Cancel
          </button>
          <button
            (click)="saveAndClose()"
            class="btn btn-success"
            style="margin-top:10px; float:right"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
